export { default } from './ProductAdd'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductAdd/index.js